<footer>
  <p>©2021 - C.Medical Co., Ltd. All Rights Reserved.</p>
</footer>
